/**
 * Different BusyIndicator text placements.
 *
 * @public
 */
enum BusyIndicatorTextPlacement {
	/**
	 * The text will be displayed on top of the busy indicator.
	 * @public
	 */
	Top = "Top",

	/**
	 * The text will be displayed at the bottom of the busy indicator.
	 * @public
	 */
	Bottom = "Bottom",
}

export default BusyIndicatorTextPlacement;
